import { useContext } from 'react';

import type { InvoicesDataContextValue } from './InvoicesDataContext.types';

import { InvoicesDataContext } from './InvoicesDataProvider';

export function useInvoicesData(): InvoicesDataContextValue {
  const context = useContext(InvoicesDataContext);
  if (!context) {
    throw new Error('useInvoicesData must be used within InvoicesDataProvider');
  }
  return context;
}
